<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-head">
            <h1>{{ title }}</h1>
          </div>

          <div class="modal-delete" @click="cancel">
            <i class="i-modal-delete"></i>
          </div>

          <div class="modal-con check">
            <div class="modal-txt">
              <ul class="check-ul">
                <li class="form-li" v-for="item in cancelReason" :key="item.value">
                  <div class="radio-box">
                    <label class="radio">
                      <input type="radio" name="radio" :value="item.value" v-model="form.cancelReason" />
                      <span class="radio-txt">{{ item.label }}</span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn yd-cta yd-cta--secondary" @click="cancel">{{ rejectText }}</button>
              <button class="btn yd-cta yd-cta--destructive" @click="confirm">{{ confirmText }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, toRefs } from 'vue';
import { useStore } from 'vuex';
import Util from '@/common/utils/Util';
import { cloneDeep } from 'lodash';

const { translator } = Util;
const $store = useStore();
const { data } = defineProps(['data']);
const emits = defineEmits(['close']);

const { title = '', confirmText = '', rejectText = '' } = toRefs(data);
const form = ref(data.form);
const cancelReason = computed(() => {
  let constants = Object.values($store.getters['constant/getConstant'][['ORDER_CANCEL_REASON']]);
  constants.splice(constants.length - 1, 1);
  return constants.map((elem) => {
    return {
      label: translator(elem),
      value: elem.key
    };
  });
});

const cancel = () => emits('close');
const confirm = () => {
  let cloneData = cloneDeep(form.value);
  const { cancelReason } = form.value;
  if (!cancelReason) return;

  const payload = {
    orderNo: cloneData.order.orderNo,
    orderState: cloneData.orderState,
    orderType: cloneData.order.orderType,
    orderManageNo: cloneData.order.orderManageNo,
    cancelReason: cancelReason,
    storeUserNo: cloneData.storeUserNo,
    userNo: cloneData.order.userNo,
    nameKr: cloneData.store.nameKr,
    nameVn: cloneData.store.nameVn,
    nameEn: cloneData.store.nameEn
  };

  $store.dispatch('admin_order/CHANGE_ORDER_STATE', payload);
  cancel();
};
</script>

<style scoped></style>
/* *Created on 2023-10-27 *ProjectName user */
